import { render, staticRenderFns } from "./AfterSendMessageModal.vue?vue&type=template&id=dd396af6&"
import script from "./AfterSendMessageModal.vue?vue&type=script&lang=js&"
export * from "./AfterSendMessageModal.vue?vue&type=script&lang=js&"
import style0 from "./AfterSendMessageModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports